<template>
    <transition name="slide-fade" mode="out-in">
        <router-view></router-view>
    </transition>
</template>

<style>
    .fade-enter-active,
    .fade-leave-active {
        transition: opacity 0.5s;
    }

    .fade-enter,
    .fade-leave-active {
        opacity: 0;
    }

    .slide-fade-enter-active {
        transition: all 0.2s ease;
    }

    .slide-fade-leave-active {
        transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
    }

    .slide-fade-enter,
    .slide-fade-leave-to {
        opacity: 0;
    }
</style>
<script>
    import Vue from 'vue';
    import sidebar from '../components/sidebar.vue'

    export default {
        data() {
            return {
            }
        },
        computed: {
        },
        methods: {
        },
        beforeMount: function () {
        },
        mounted() {
        },
        components: {
            sidebar
        }
    }
</script>
